import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import { getUserToken } from '@/utils/cookies';
import { hexSha1 } from '@/utils/sha1';
import { UserModule } from '@/store/modules/user';
const APP_ID = 'app_id';
const ORDER_ID = 'order_id';
const USER_ID = 'user_id';
const COMPANY_ID = 'main_company';
const TIMESTAP = 'timestamp';
const SIGN = 'sign';
const USERTOKEN = 'userToken';
const APP_ID_VALUE = 'xZZLNMmaHgdIWJwx';
const SECREKEY = 'YSsbZUVhKD7CSJbpb2ZOJCFDibwM05nl';
const AGENT = '211736';
const ALLIANCE = '221710';
const BASE_API = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_API_DEV;
const API_ROOT = location.protocol + BASE_API;
const APPVERSION = process.env.VUE_APP_VERSION;
// 每次请求携带cookies信息
axios.defaults.withCredentials = true;

const service = axios.create({
  baseURL: location.protocol + process.env.VUE_APP_BASE_API,
  timeout: 5000 * 6 * 2 * 5
});

// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    (config).headers = getHader();
    config.url = getUrl(config);
    let token :any = getUserToken();
    if (token) {
      if (typeof token !== 'object') {
        token = JSON.parse(token as string);
      }
    }
    if (token && token.token) {
      config.headers.userToken = token.token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptors
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 0) {
      if (res.code === 90003) {
        MessageBox.confirm(
          '是否重新登录',
          '退出登陆',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(async() => {
          await UserModule.ResetToken();
          window.location.href = location.protocol + process.env.VUE_APP_LOGIN_URL;
        });
      }
      return Promise.reject(res || new Error('Error'));
    } else {
      return response.data;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
/**
 * 获取hader
 */
function getHader() {
  var hader = {
    // 'content-type': 'application/x-www-form-urlencoded',
    // 'cache-control': 'no-cache',
    'content-type': 'application/json', // 默认值
    'sourceCode': '100101',
    'platformCode': '103000',
    'deviceType': 'web',
    'appVersion': APPVERSION,
    // 'userToken': '',
    'deviceId': 'webid'
  };
  return hader;
}
/**
 * 获取接口url 拼接baseurl
 * @param urlName 接口名称 必填
 * @param order_id  选填
 * @param user_id 选填
 * @param company_id 选填
 * @returns {String}
 */
export function getUrl(config: any) {
  let url = API_ROOT;
  url += config.url + '?';
  let arr = [];
  let appid = paramAppend(APP_ID, APP_ID_VALUE);
  if (!isEmpty(appid)) {
    arr.push(appid);
  }
  let orderid: string = '';
  if (config.data && !isEmpty(config.data.order_id)) {
    orderid = config.data.order_id;
  } else {
    if (config.params && !isEmpty(config.params.order_id)) {
      orderid = config.params.order_id;
    }
  }
  if (!isEmpty(orderid)) {
    let oid = paramAppend(ORDER_ID, orderid);
    arr.push(oid);
  }
  let userid: string = '';
  if (config.data && !isEmpty(config.data.user_id)) {
    userid = config.data.user_id;
  } else {
    if (config.params && !isEmpty(config.params.user_id)) {
      userid = config.params.user_id;
    }
  }
  if (!isEmpty(userid)) {
    let uid = paramAppend(USER_ID, userid);
    arr.push(uid);
  }
  let companyid: string = '';
  if (config.data && !isEmpty(config.data.company_id)) {
    companyid = config.data.company_id;
  } else {
    if (config.params && !isEmpty(config.params.company_id)) {
      companyid = config.params.company_id;
    }
  }
  if (!isEmpty(companyid)) {
    let cid = paramAppend(COMPANY_ID, companyid);
    arr.push(cid);
  }
  let timestap = paramAppend(TIMESTAP, String(Date.parse(String(new Date())) / 1000));
  if (!isEmpty(timestap)) {
    arr.push(timestap);
  }
  if (arr.length > 0) {
    url += arr.join('&');
  }
  url = url + '&' + paramAppend(SIGN, sign(config.url, orderid, userid, companyid));
  url = url + '&agent_code=' + AGENT + '&alliance_code=' + ALLIANCE;
  return url;
}

/**
 * 计算签名
 * @param urlName 接口名称 必填
 * @param order_id  选填
 * @param user_id 选填
 * @param company_id 选填
 * @returns {String}
 */
function sign(url: string, orderIdddd: string, userIdddd: string, companyIdddd: string) {
  let list = [];
  let appid = paramSignAppend(APP_ID, APP_ID_VALUE);
  if (!isEmpty(appid)) {
    list.push(appid);
  }
  let orderid = paramSignAppend(ORDER_ID, orderIdddd);
  if (!isEmpty(orderid)) {
    list.push(orderid);
  }
  let userid = paramSignAppend(USER_ID, userIdddd);
  if (!isEmpty(userid)) {
    list.push(userid);
  }
  let companyid = paramSignAppend(COMPANY_ID, companyIdddd);
  if (!isEmpty(companyid)) {
    list.push(companyid);
  }
  let timestap = paramSignAppend(TIMESTAP, String(Date.parse(String(new Date())) / 1000));
  if (!isEmpty(timestap)) {
    list.push(timestap);
  }
  let temp = url + SECREKEY + list.sort().join('');
  let temp2 = hexSha1(temp);
  return temp2.toLowerCase();
}

function paramAppend(k: string, v: string) {
  let r = '';
  if (!isEmpty(v)) {
    r = k + '=' + v;
  }
  return r;
}

function paramSignAppend(k: string, v: string) {
  let r = '';
  if (!isEmpty(v)) {
    r = (k + v);
  }
  return r;
}
function isEmpty(str: any) {
  return str === '' || str == null;
}
export default service;
